export default __webpack_public_path__ + "static/media/note_mobile.da373d29.png";